<template>
  <div class="container">
    <account-description :title="$t('digital.fingerprint')">
      <span v-html="$t('digital.fingerprint.page.description')" />
    </account-description>
    <digital-fingerprint-list />
  </div>
</template>

<script>
import AccountDescription from '@/components/account/AccountDescription.vue';
import DigitalFingerprintList from '@/components/account/digitalFingerprint/DigitalFingerprintList.vue';

export default {
  components: {
    AccountDescription,
    DigitalFingerprintList,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors';

.container {
  padding-bottom: 50px;
}
</style>
